import React, { Component } from 'react';
import { connect } from 'react-redux';
import { envValue } from '../../../../config/envUtils';
const SOURCEURL = envValue('SOURCEURL');

function _normalizeWeight(weight) {
    if (weight === '400') return 'normal';
    if (weight === '700') return 'bold';
    return weight.toLowerCase();
}

function generateFontFace(fontName, font) {
    return Object.entries(font.files)
        .map(([variant, fileUrls]) => {
            let [style, weight] = variant.split(':');
            let ie9 = '';
            let other = [];
            weight = _normalizeWeight(weight);
            fileUrls.forEach(url => {
                const ext = /.*\.(.*)$/.exec(url);
                const absoluteUrl = `${SOURCEURL}/${url}`;
                if (ext !== null && ext.length > 1) {
                    switch (ext[1].toLowerCase()) {
                        case 'eot':
                            ie9 += `src: url('${absoluteUrl}');`;
                            other.push(`url('${absoluteUrl}?#iefix') format('embedded-opentype')`);
                            break;
                        case 'svg':
                            other.push(`url('${absoluteUrl}#${fontName}') format('svg')`);
                            break;
                        case 'ttf':
                            other.push(`url('${absoluteUrl}') format('truetype')`);
                            break;
                        case 'otf':
                            other.push(`url('${absoluteUrl}') format('opentype')`);
                            break;
                        default:
                            other.push(`url('${absoluteUrl}') format('${ext[1].toLowerCase()}')`);
                    }
                }
            });
            return `@font-face {
	font-family: ${fontName};
	${ie9}
	src: ${other.join(', ')}; ${style !== 'normal' ? `\n font-style: ${style};\n ` : ''} ${
                weight !== 'normal' ? `font-weight: ${weight};` : ''
            }
}`;
        })
        .join('\n');
}

function generateFontFaces(faces) {
    return Object.entries(faces)
        .map(([fontName, files]) => generateFontFace(fontName, files))
        .join('\n');
}

class FontLoaderBase extends Component {
    constructor(...args) {
        super(...args);
        this.mountPoint = document.getElementsByTagName('head')[0];
        this.el = document.createElement('style');
        this.el.id = 'fontLoader';
    }
    componentDidMount() {
        this.mountPoint.insertBefore(this.el, this.mountPoint.firstChild);
        this.el.innerHTML = generateFontFaces(this.props.availableFontFamilies);
    }
    componentDidUpdate() {
        this.el.innerHTML = generateFontFaces(this.props.availableFontFamilies);
    }
    componentWillUnmount() {
        this.mountPoint.removeChild(this.el);
    }
    render() {
        return null;
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        availableFontFamilies: state.theme.fonts
    };
};

const FontLoader = connect(mapStateToProps)(FontLoaderBase);
export { FontLoader, generateFontFace, generateFontFaces };



// WEBPACK FOOTER //
// ./src/components/widgets/FontLoader/FontLoader.js